import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  ListItemText,
  Checkbox,
  Box,
  Chip,
  type SelectProps as MuiSelectProps,
} from '@mui/material';
import { type UseControllerReturn } from 'react-hook-form';
import { type AvatarInfo } from '@/types';
import Avatar from '../Avatar';
import styles from './styles';

type SelectFieldProps = {
  field?: UseControllerReturn['field'];
  options?: { label: any; value: any; user?: AvatarInfo }[];
  helperText?: string;
} & MuiSelectProps;

const SelectField = ({
  field,
  options,
  label,
  size = 'small',
  error,
  helperText,
  multiple,
  ...props
}: SelectFieldProps) => (
  <FormControl fullWidth size={size} error={error}>
    <InputLabel>{label}</InputLabel>

    <Select
      {...field}
      label={label}
      multiple={multiple}
      renderValue={(value: any[]) => {
        if (multiple) {
          return (
            <Box sx={styles.valueContainer}>
              {value.map((value: any) => {
                const selectedValue = options?.find(
                  (option) => option.value === value,
                );

                return <Chip key={value} label={selectedValue?.label} />;
              })}
            </Box>
          );
        }

        const selectedValue = options?.find((option) => option.value === value);

        return (
          <Box sx={styles.valueContainer}>
            {selectedValue?.user && <Avatar user={selectedValue.user} />}
            <ListItemText>{selectedValue?.label}</ListItemText>
          </Box>
        );
      }}
      {...props}
    >
      {options?.map((option, index) => (
        <MenuItem key={index} value={option.value} sx={styles.valueContainer}>
          {multiple && (
            <Checkbox checked={field?.value.includes(option.value)} />
          )}

          {option?.user && <Avatar user={option.user} />}
          <ListItemText>{option.label}</ListItemText>
        </MenuItem>
      ))}
    </Select>

    {error && <FormHelperText>{helperText}</FormHelperText>}
  </FormControl>
);

export default SelectField;
